import { useEffect, useState } from 'react';
import useReveal from '@/hooks/useReveal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import HotComics from './components/HotComics';
import Categories from './components/Categories';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Cta from './components/Cta';
import Footer from './components/Footer';
import JsonLd from './components/JsonLd';
import { faqs, featuredComics } from '@/mocks/comics';

export default function Home() {
  useReveal();
  const [activeCate, setActiveCate] = useState('全部');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const faqData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  const itemListData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '178漫画网一起看漫画专区热门作品',
    itemListElement: featuredComics.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.title,
      description: c.intro,
    })),
  };

  return (
    <div className="min-h-screen">
      <JsonLd id="jsonld-faq" data={faqData} />
      <JsonLd id="jsonld-itemlist" data={itemListData} />

      <Navbar />
      <main>
        <Hero />
        <Features />
        <HotComics activeCate={activeCate} onCateChange={setActiveCate} />
        <Categories onSelect={setActiveCate} />
        <HowItWorks />
        <Testimonials />
        <Faq />
        <Cta />
      </main>
      <Footer />

      <button
        type="button"
        aria-label="返回顶部"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 cursor-pointer ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}